/**
 * 쿠폰 배너 그림 — <picture> webp + jpg 대체. 고유 width/height 를 넣어 비율 상자를 미리 잡는다(CLS 0).
 * 광고 그림과 같이 fetchPriority=low(LCP 와 다투지 않음). 클래스·스타일은 호출부(유료 광고 틀의 img 규칙)를 그대로 받는다.
 */
import type { CSSProperties } from 'react';
import { PROMO_IMG, PROMO_SLOT_ALT, type PromoImgKind } from '@/lib/ads/promo-slot';

export default function PromoPicture({ kind, eager = false, style }: { kind: PromoImgKind; eager?: boolean; style?: CSSProperties }) {
  const im = PROMO_IMG[kind];
  return (
    <picture>
      <source srcSet={im.webp} type="image/webp" />
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={im.jpg} alt={PROMO_SLOT_ALT} width={im.width} height={im.height} decoding="async" loading={eager ? undefined : 'lazy'} fetchPriority="low" style={style} data-ad-promo-img={kind} />
    </picture>
  );
}
